/**
 * ヘッダーのスクロール制御を行うモジュール
 * - 下方向スクロール時: ヘッダーを非表示
 * - 上方向スクロール時: ヘッダーを表示
 * - スクロール停止2秒後: ヘッダーを表示
 * - ファーストビュー内: 常に表示
 */
export const initHeaderControl = () => {
    const header = document.getElementById('header');
    if (!header) return;

    // ヘッダーの高さを取得してbodyにpadding-topを設定
    const setMainPadding = () => {
        if (window.location.pathname === '/') {
            document.body.style.paddingTop = '';
        } else {
            const headerHeight = header.offsetHeight;
            document.body.style.paddingTop = `${headerHeight}px`;
        }
    };

    let lastScrollY = window.scrollY;
    let scrollTimeout = null;
    let isScrolling = false;

    // ヘッダーの表示/非表示を制御
    const controlHeader = (show) => {
        header.style.transform = show ? 'translateY(0)' : 'translateY(-100%)';
        header.style.transition = 'transform 0.3s ease-in-out';
    };

    // スクロール中の処理
    const handleScroll = () => {
        if (!isScrolling) {
            isScrolling = true;
            requestAnimationFrame(() => {
                const currentScrollY = window.scrollY;
                const viewportHeight = window.innerHeight / 4;

                // ページ上部の場合は常に表示
                if (currentScrollY <= viewportHeight) {
                    controlHeader(true);
                } else {
                    // スクロール方向の判定
                    const isScrollingDown = currentScrollY > lastScrollY;

                    // スクロール方向に応じてヘッダーの表示/非表示を制御
                    if (isScrollingDown) {
                        controlHeader(false);
                    } else {
                        controlHeader(true);
                    }
                }

                lastScrollY = currentScrollY;
                isScrolling = false;
            });
        }

        // スクロール停止タイマーをリセット
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            // スクロール停止から2秒後にヘッダーを表示
            controlHeader(true);
        }, 2000);
    };

    // 初期設定
    setMainPadding();

    // ウィンドウリサイズ時にもpadding-topを再計算
    const handleResize = () => {
        setMainPadding();
        // リサイズ時にもスクロール位置をチェック
        handleScroll();
    };
    window.addEventListener('resize', handleResize);

    // スクロールイベントの登録
    window.addEventListener('scroll', handleScroll, { passive: true });

    // 初期状態ではヘッダーを表示
    controlHeader(true);

    // イベントリスナーのクリーンアップ関数を返す
    return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        // クリーンアップ時にpadding-topをリセット
        document.body.style.paddingTop = '';
    };
};

// ヘッダーのスクロール制御
let headerControlCleanup = null;
document.addEventListener('turbolinks:load', () => {
    // 前回のイベントリスナーをクリーンアップ
    if (headerControlCleanup) {
        headerControlCleanup();
    }
    // 新しいイベントリスナーを設定
    headerControlCleanup = initHeaderControl();
});

document.addEventListener('turbolinks:before-cache', () => {
    if (headerControlCleanup) {
        headerControlCleanup();
        headerControlCleanup = null;
    }
});